class GiftCardHistoric {

  constructor($container) {
    this.$container = $container;
    this.$table = this.$container.find('#giftcard-balance-table');
    this.$giftCardNumber = this.$container.find('#giftcard-balance-giftcard-number');
    this.$balance = this.$container.find('#giftcard-balance-balance');
    this.$validityDate = this.$container.find('#giftcard-balance-validitydate');
    this.$tbody = $('<tbody></tbody>');
    this.$debitBadge = $('<span class="status-type status-type--blue">Debit</span>');
    this.$adjustementBadge = $('<span class="status-type status-type--orange">Adjustement</span>');
    this.$creditBadge = $('<span class="status-type status-type--green">Credit</span>');
    this.$table.append(this.$tbody);
  };

  addRow(detailLine) {
    const $tdStore = $(`<td>${  detailLine.store  } <span>${  detailLine.transactionDate  }</span></td>`);

    const $tdProcessing = $('<td></td>');
    if (detailLine.amount < 0) {
      $tdProcessing.append(this.$debitBadge.clone());
    }
    else if (detailLine.amount > 0) {
      $tdProcessing.append(this.$creditBadge.clone());
    }

    const $tdAmount = $(`<td>${  detailLine.amount / 100  } ${  detailLine.currencyDisplayCode  }</td>`);
    const $tdDate = $(`<td>${  detailLine.transactionDate  }</td>`);
    const $tr = $('<tr></tr>').append($tdStore).append($tdProcessing).append($tdAmount).append($tdDate);
    this.$tbody.append($tr);
  };

  setOverallInfo(data) {
    this.$giftCardNumber.text(data.cardNumber);
    this.$balance.text(`${data.balance / 100  } ${  data.currencyDisplayCode}`);
    this.$validityDate.text(data.expiryDate);
  };

  initialize(data) {
    this.setOverallInfo(data);
    Object.values(data.responseDetail).forEach(line => {
      this.addRow(line);
    });
    this.$container.show();

    const positionToScroll = this.$container.offset().top - 70;

    $.scrollTo(positionToScroll, {
      axis: 'y',
      duration: 500
    });
  };

  clear() {
    this.$container.hide();
    this.$tbody.empty();
    this.$giftCardNumber.text('');
    this.$balance.text('');
    this.$validityDate.text('');
  };
}

export function init() {

  /**
   * Gift card balance page
   */

  const giftCardBalanceContainer = $('#giftcard-balance-container');

  if (giftCardBalanceContainer) {
    cube.lazyLoadCaptcha();

    window.setCaptchaChecked = () => {
      window.decathlon.captcha.isCaptchaChecked = true;
    };

    window.setCaptchaUnchecked = () => {
      window.decathlon.captcha.isCaptchaChecked = false;
    };

    const giftCardHistoric = new GiftCardHistoric(giftCardBalanceContainer);

    const giftCardBalanceSuccessCb = ($form, result) => {
      giftCardHistoric.initialize(result.responseTO.data);
      window.decathlon.captcha.resetCaptcha();
    };

    const giftCardBalanceErrorCb = ($form, result) => {
      const error = result.responseTO.errors[0];
      if (error) {
        $('body').pushAlert({type: 'danger', text: error.message, icon: 'bell'});
      }
      window.decathlon.captcha.resetCaptcha();

    };

    $('#giftcard-history-form [type="submit"]').on('click', () => {
      giftCardHistoric.clear();
    });

    const giftCardHistoryForm = $('#giftcard-history-form');
    giftCardHistoryForm.handleform('init', {successCb: giftCardBalanceSuccessCb, errorCb: giftCardBalanceErrorCb});
    giftCardHistoryForm.validate($.extend(null, $.validator.cubeOptions));

  }
}



// WEBPACK FOOTER //
// ./src/standalone/giftCardHistory.js